var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.8478C16 15.208 15.7083 15.5 15.3478 15.5H1.65217C1.29172 15.5 1 15.208 1 14.8478V1.15217C1 0.792043 1.29172 0.5 1.65217 0.5C2.01263 0.5 2.30435 0.792043 2.30435 1.15217V11.3169L7.06065 6.56059C7.31539 6.30585 7.72809 6.30585 7.98289 6.56059L9.44643 8.02413L13.1766 3.7608H12.087C11.7265 3.7608 11.4348 3.46876 11.4348 3.10863C11.4348 2.7485 11.7265 2.45646 12.087 2.45646H14.6027C14.8861 2.45646 15.1376 2.63985 15.2236 2.91024L15.9688 5.24222C16.0789 5.5852 15.8891 5.95237 15.5465 6.06187C15.4802 6.08287 15.4134 6.09311 15.3478 6.09311C15.0714 6.09311 14.8153 5.91637 14.7268 5.639L14.3361 4.41715L9.96928 9.40778C9.85019 9.54343 9.68011 9.62398 9.49991 9.63004C9.31391 9.63135 9.14389 9.56665 9.01717 9.43928L7.52174 7.94385L2.30435 13.1612V14.1955H15.3478C15.7083 14.1955 16 14.4877 16 14.8478Z",
    fill: "#013DB9",
    stroke: "#013DB9",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceFileIcon);
export default __webpack_public_path__ + "static/media/voice-file-icon.b78600e9425a1e6db448b86bc43b079c.svg";
export { ForwardRef as ReactComponent };